/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPaperclipIcon32Regular = forwardRef('AttachPaperclipIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M19.291 6.428a5.842 5.842 0 1 1 8.262 8.262l-10.65 10.65A8.263 8.263 0 1 1 5.217 13.654l7.488-7.487a1 1 0 1 1 1.414 1.414l-7.488 7.488a6.263 6.263 0 0 0 8.858 8.857l10.65-10.65a3.842 3.842 0 0 0-5.434-5.434L9.925 18.623a1.421 1.421 0 0 0 2.01 2.01l7.618-7.619a1 1 0 0 1 1.414 1.415l-7.619 7.618A3.421 3.421 0 1 1 8.51 17.21l10.781-10.78Z" })));
});
